"use server";

import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";
import fs from "node:fs/promises";
import path from "node:path";
import crypto from "node:crypto";
import { prisma } from "@/lib/prisma";
import { belepesKotelezo } from "@/lib/auth";
import type { AlvallalkozoiElbiralasAllapot } from "@/generated/prisma";

function ures(ertek: FormDataEntryValue | null) {
  const szoveg = String(ertek || "").trim();
  return szoveg === "" ? null : szoveg;
}

async function ceglogoMentese(fajl: File): Promise<string> {
  const kiterjesztes = (fajl.type.split("/")[1] || "png").replace("jpeg", "jpg");
  const fajlnev = `${crypto.randomUUID()}.${kiterjesztes}`;
  const mappa = path.join(process.cwd(), "public", "storage", "alvallalkozok");
  await fs.mkdir(mappa, { recursive: true });
  const buffer = Buffer.from(await fajl.arrayBuffer());
  await fs.writeFile(path.join(mappa, fajlnev), buffer);
  return `/storage/alvallalkozok/${fajlnev}`;
}

export async function alvallalkozoJelentkezesBekuldese(formData: FormData) {
  const cegnev = String(formData.get("cegnev") || "").trim();
  const szekhely_irsz = String(formData.get("szekhely_irsz") || "").trim();
  const szekhely_telepules = String(formData.get("szekhely_telepules") || "").trim();
  const szekhely_kozterulet = String(formData.get("szekhely_kozterulet") || "").trim();
  const cegjegyzekszam = String(formData.get("cegjegyzekszam") || "").trim();
  const adoszam = String(formData.get("adoszam") || "").trim();
  const kepviselo_nev = String(formData.get("kepviselo_nev") || "").trim();
  const kapcsolattarto_nev = String(formData.get("kapcsolattarto_nev") || "").trim();
  const kapcsolattarto_telefon = String(formData.get("kapcsolattarto_telefon") || "").trim();
  const kapcsolattarto_email = String(formData.get("kapcsolattarto_email") || "").trim().toLowerCase();

  if (
    !cegnev ||
    !szekhely_irsz ||
    !szekhely_telepules ||
    !szekhely_kozterulet ||
    !cegjegyzekszam ||
    !adoszam ||
    !kepviselo_nev ||
    !kapcsolattarto_nev ||
    !kapcsolattarto_telefon ||
    !kapcsolattarto_email
  ) {
    redirect("/partner-portal?hiba=hianyzo_adat#jelentkezes");
  }

  const vallalhato_szolgaltatasok = formData.getAll("vallalhato_szolgaltatasok").map((ertek) => String(ertek));

  let ceglogo_url: string | null = null;
  const ceglogo = formData.get("ceglogo") as File | null;
  if (ceglogo && ceglogo.size > 0) {
    ceglogo_url = await ceglogoMentese(ceglogo);
  }

  await prisma.alvallalkozoiJelentkezes.create({
    data: {
      cegnev,
      szekhely_irsz,
      szekhely_telepules,
      szekhely_kozterulet,
      mukodesi_hely: ures(formData.get("mukodesi_hely")),
      cegjegyzekszam,
      adoszam,
      kepviselo_nev,
      kepviselo_beosztas: ures(formData.get("kepviselo_beosztas")),
      kapcsolattarto_nev,
      kapcsolattarto_beosztas: ures(formData.get("kapcsolattarto_beosztas")),
      kapcsolattarto_telefon,
      kapcsolattarto_email,
      ceglogo_url,
      vallalhato_szolgaltatasok,
    },
  });

  redirect("/partner-portal?siker=1#jelentkezes");
}

export async function alvallalkozoElbiralasValt(formData: FormData) {
  await belepesKotelezo();

  const id = String(formData.get("id") || "");
  const elbiralasi_allapot = String(formData.get("elbiralasi_allapot") || "") as AlvallalkozoiElbiralasAllapot;
  if (!id || !elbiralasi_allapot) return;

  await prisma.alvallalkozoiJelentkezes.update({ where: { id }, data: { elbiralasi_allapot } });

  revalidatePath("/admin/alvallalkozok");
  revalidatePath(`/admin/alvallalkozok/${id}`);
}
